module.exports = __webpack_public_path__ + "assets/e69ee3a83e45930713bc1e1e28b622ff.png";